// На стр.  Функционал сервиса
export function showFunctionalCards() {
  const cards = document.querySelectorAll(
    ".category-funkczional-servisa .functionality__card"
  );
  const showMoreBtn = document.querySelector(
    ".category-funkczional-servisa .functionality__button-show"
  );

  if (!(cards.length && showMoreBtn)) return;

  showMoreBtn.textContent = `Показать еще (${cards.length - 6})`;

  cards.forEach((card, index) => {
    if (index >= 6) {
      card.classList.add("hidden");
    }
  });

  if (cards.length <= 6) {
    showMoreBtn.style.display = "none";
  }

  showMoreBtn.addEventListener("click", () => {
    cards.forEach(card => {
      card.style.display = "block";
    });

    showMoreBtn.style.display = "none";
  });
}
